








import {isVerySmallScreen} from "@/set/search/ScreenUtils";
import {getViewerUrl} from "@/set/search/setSearch";
import {SetState} from "@/set/set_store";
import Vue from 'vue'
import {mapState} from "vuex";

export default Vue.extend({
  props: {
    docHref: String, //https://www.set.or.th/dat/news/202011/20122824.pdf
  },
  computed: {
    ...mapState('set', {
      viewerConfig: state => (state as SetState).viewerConfig,
      useGoogleDriveViewer: state => (state as SetState).useGoogleDriveViewer
    }),
    srcHref(): string {
      return getViewerUrl(this.docHref, this.viewerConfig.engine, this.useGoogleDriveViewer)
    },
    isVerySmallScreen: isVerySmallScreen
  }
})
